import { Text } from "@merge-api/merge-javascript-shared";
interface Props {
  stepImg: string | undefined;
  icon?: JSX.Element;
  title: string;
}

const StepCardIcon = ({ stepImg, icon, title }: Props) => {
  return (
    <div className="self-center">
      {stepImg ? (
        <img src={stepImg} className="card-image items-center" alt="" />
      ) : (
        <div className="w-[45px] h-[45px] rounded-[5px] border border-gray-10 flex items-center justify-center bg-green-60 text-white">
          {icon ?? <Text variant="h4">{title.charAt(0)}</Text>}
        </div>
      )}
    </div>
  );
};

export default StepCardIcon;
